















































































































































































































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import chooseAttr from "./chooseAttr.vue";
import gql from "graphql-tag";
// import apollo from "vue-apollo";
// import { queryRelatedAttrValue } from "@/graphql/Products.gql";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import editMultiLanguage from "./editMultiLanguage.vue";
import multiLangEnter from "@/components/pages/ProductCreate/multiLangEnter.vue";
const productCreate = namespace("productCreate");
const Root = namespace("root");
import { NumberRule, fomatLocaletoArray } from "@root/lib/common";
import { ProductChildren } from "@root/lib/mixins";
import { FormVaildateToOut } from "@root/lib/decorator";

function rules() {
  /*
attrValueType
0：单选；1：多选；2：输入框；3：数字；4：富文本；5：日期；6：对象'
*/
  return {
    "0": { required: false },
    "1": { required: false, type: "array" },
    "2": {
      max: 1000,
      message: this.$t("Basic.required_1000_char")
    },
    "3": {
      validator: NumberRule.bind(this)
    },
    "4": {
      max: 1000,
      message: this.$t("Basic.required_1000_char")
    }
  };
}
@Component({
  components: { chooseAttr, editMultiLanguage, multiLangEnter }
  // apollo: {
  //   attrList: {
  //     query: queryRelatedAttrValue,
  //     variables() {
  //       return {
  //         input: {
  //           channel: localStorage.getItem("channel"),
  //           orgCode: localStorage.getItem("org") || "default",
  //           codeList: [{ relationCode: this.productCode, attrType: 1 }]
  //         }
  //       };
  //     },

  //     update: data => {
  //       const list =
  //       const list =
  //         (data.queryRelatedAttrValue.length &&
  //           data.queryRelatedAttrValue[0].relatedAttrValueList) ||
  //         [];
  //       const filterList = list.map(item => {
  //         const filterValue = item.attrValueList.map(cell => cell.attrValue);
  //         return {
  //           ...item,
  //           attrValueList:
  //             item.attrValueType === 1 ? filterValue : filterValue[0]
  //         };
  //       });
  //       return filterList;
  //     },
  //     skip() {
  //       return !this.isEdit;
  //     }
  //   }
  // }
})
@FormVaildateToOut("form", {
  resCbName: "resFormart"
})
export default class Attribute extends Mixins(ProductChildren) {
  ruleForm: any = {
    attrList: []
  };
  rules: any = null;
  org: string = "default";
  productCode: string | (string | null)[] = "";
  attrList: any = [];
  deleteData: any = [];
  loading: boolean = false;
  conditionList: any = [
    {
      key: "attrType",
      value: 1,
      type: 0
    }
  ];

  multiLangAttrObj = {};
  curLocale = localStorage.getItem("localeLanguage");

  @Prop({ default: false })
  isEdit!: boolean;
  @Prop({ default: false }) readonly;
  @productCreate.Getter propertiesData;
  @productCreate.Action updateProduct;
  @productCreate.Action queryProductInfo;
  @productCreate.State productInfo;
  @productCreate.State skuAttrData;
  @Root.State languageList;
  @productCreate.State familySpuList;
  @productCreate.Action querySkuAttrData: any;

  @Watch("attrList")
  onAttrListChange(val, oldVal) {
    this.ruleForm.attrList = [...val];
    this.iniAttrLocales();
  }
  @Watch("familySpuList")
  watchFamilySpuList(val, oldVal) {
    if (val && !this.isEdit) {
      this.ruleForm.attrList = [...val];
      this.iniAttrLocales();
    }
  }

  @Watch("languageList")
  watchlanguageList(val) {
    this.iniAttrLocales();
  }

  @Watch("productInfo")
  watchproductInfo(val) {
    this.iniAttrLocales();
  }
  iniAttrLocales() {
    if (this.languageList.length <= 0 && this.attrList.length <= 0) {
      return;
    }
    this.initLangItem();
    let allObj = this.productInfo.extendParams
      ? JSON.parse(this.productInfo.extendParams)
      : {};

    this.attrList.forEach(item => {
      if (!this.isMultiLangAttr(item)) {
        return;
      }
      let { attrCode } = item;
      if (allObj[attrCode] && allObj[attrCode]["[AC]"]) {
        this.$set(this.multiLangAttrObj, attrCode, {
          ...this.initLangObj,
          ...allObj[attrCode]["[AC]"]
        });
      } else {
        this.$set(this.multiLangAttrObj, attrCode, { ...this.initLangObj });
      }
    });
  }
  initLangObj = {};
  initLangItem() {
    this.languageList.forEach((_, index) => {
      if (!this.initLangObj[_.value]) {
        this.$set(this.initLangObj, _.value, "");
      }
    });
  }
  mounted() {
    this.rules = rules.apply(this);
    this.productCode = this.$route.query.productCode;
    this.initSkuAttrData();
  }

  async initSkuAttrData() {
    const data = await this.querySkuAttrData([
      { relationCode: this.productCode, attrType: 1 }
    ]);
    const list = data && data[0] && data[0].relatedAttrValueList;
    const filterList = (list || []).map(item => {
      const filterValue = item.attrValueList.map(cell => cell.attrValue);
      return {
        ...item,
        attrValueList: item.attrValueType === 1 ? filterValue : filterValue[0]
      };
    });
    this.attrList = filterList;
  }

  handleSubmit() {
    const $form: any = this.$refs.form;
    $form.validate(valid => {
      if (valid) {
        this.save();
      }
    });
  }
  async save() {
    let localeList = [];
    for (let i in this.multiLangAttrObj) {
      localeList = [
        ...localeList,
        ...fomatLocaletoArray(this.languageList, this.multiLangAttrObj[i], i)
      ];
    }
    const filterList = [...this.ruleForm.attrList, ...this.deleteData].map(
      item => {
        let filterValue;
        if (item.attrValueType === 1) {
          filterValue = item.attrValueList.map(
            cell => (cell = { attrValue: cell })
          );
        } else if (item.attrIsRequired && this.isMultiLangAttr(item)) {
          filterValue = [
            {
              attrValue: this.multiLangAttrObj[item.attrCode]
                ? this.multiLangAttrObj[item.attrCode][this.curLocale]
                : ""
            }
          ];
        } else {
          filterValue = [{ attrValue: item.attrValueList }];
        }

        return {
          attrCode: item.attrCode,
          attrValueList: filterValue,
          logicDelete: item.logicDelete
        };
      }
    );
    if (this.isEdit) {
      this.loading = true;
      let categoryCodeList = this.propertiesData.categoryCodeList.map(
        item => (item = { categoryCode: item.categoryCode })
      );
      try {
        await this.updateProduct({
          ...this.propertiesData,
          categoryCodeList,
          relatedAttrValue: filterList,
          localeList
        });
        await this.getNewData();
        this.loading = false;
        this.deleteData = [];
        let message: any = this.$t("Basic.success");
        this["$message"].success(message);
      } catch {
        this.loading = false;
      }
    } else {
      localStorage.setItem(
        "attributeData",
        JSON.stringify({ relatedAttrValue: filterList, localeList })
      );
      this.$emit("next");
    }
  }
  resFormart() {
    let localeList = [];
    for (let i in this.multiLangAttrObj) {
      localeList = [
        ...localeList,
        ...fomatLocaletoArray(this.languageList, this.multiLangAttrObj[i], i)
      ];
    }
    const filterList = [...this.ruleForm.attrList, ...this.deleteData].map(
      item => {
        let filterValue;
        if (item.attrValueType === 1) {
          filterValue = item.attrValueList.map(
            cell => (cell = { attrValue: cell })
          );
        } else if (item.attrIsRequired && this.isMultiLangAttr(item)) {
          filterValue = [
            {
              attrValue: this.multiLangAttrObj[item.attrCode]
                ? this.multiLangAttrObj[item.attrCode][this.curLocale]
                : ""
            }
          ];
        } else {
          filterValue = [{ attrValue: item.attrValueList }];
        }

        return {
          attrCode: item.attrCode,
          attrValueList: filterValue,
          logicDelete: item.logicDelete
        };
      }
    );
    return { relatedAttrValue: filterList, localeList };
  }
  handleAddAttr() {
    const $chooseAttr: any = this.$refs.chooseAttr;
    $chooseAttr.visible = true;
  }
  handleDelete(index) {
    let message: any = this.$t("Basic.confirm_delete"),
      title: any = this.$t("Basic.Warning");
    (this as any)["$confirm"](message, title).then(res => {
      if (res) {
        delete this.multiLangAttrObj[this.ruleForm.attrList[index].attrCode];
        let del = this.ruleForm.attrList[index];
        let delItem = this.attrList.find(
          item => item.attrCode === del.attrCode
        );
        let hasRepeat = this.deleteData.find(
          item => item.attrCode === del.attrCode
        );
        this.ruleForm.attrList.splice(index, 1);
        if (hasRepeat) return;
        delItem && this.deleteData.push({ ...delItem, logicDelete: 1 });
      }
    });
  }
  handleSelectAttr(data) {
    const appendData = data.map(item => {
      let attrValueList;
      switch (item.attrValueType) {
        case 1:
          attrValueList = [];
          break;
        default:
          attrValueList = "";
          break;
      }

      if (this.isMultiLangAttr(item)) {
        this.$set(this.multiLangAttrObj, item.attrCode, {
          ...this.initLangObj
        });
      }
      // 如果之前保存删除属性的 deleteData 数组中有当前属性，则需要删除deleteData中的该属性
      let index = this.deleteData.findIndex(_ => item.attrCode === _.attrCode);

      if (index !== -1) {
        this.deleteData.splice(index, 1);
      }
      //  this.ruleForm[item.attrCode] = attrValueList;
      // this.ruleForm = { ...this.ruleForm };
      return {
        ...item,
        attrValueList
      };
    });
    this.ruleForm.attrList = [...this.ruleForm.attrList, ...appendData];
  }
  handlePrev() {
    this.$emit("prev");
  }
  async getNewData() {
    let res = await this.queryProductInfo(this.propertiesData.productCode);
  }
  inputType = "text";
  editMultiOption(item) {
    const $edit: any = this.$refs.multiOptionDialog;
    $edit.dialogVisible = true;
    this.curEditAttr = item.attrCode;
    this.inputType = item.attrValueType === 4 ? "textarea" : "text";
  }
  // 编辑productName多语言
  curEditAttr: any = "";
  saveMultiOption(data) {
    this.multiLangAttrObj[this.curEditAttr] = { ...data };
    const $edit: any = this.$refs.form;
  }
  isAllMultiLang(code) {
    return this.languageList.every(_ => {
      let value = this.multiLangAttrObj[code]
        ? this.multiLangAttrObj[code][_.value]
        : "";
      return !!value;
    });
  }
  isMultiLangAttr(item) {
    return !!([2, 4].includes(item.attrValueType) && item.attrIsLanguage);
  }
  multiAttrValidator(rule, value, callback) {
    let all = this.isAllMultiLang(value);
    if (!value || !all) {
      let info: any = this.$t("Basic.required_msg");
      callback(new Error(info));
    }
    callback();
  }
}
